import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Image from "gatsby-plugin-sanity-image"
import { styled, media } from "../mediaCSS"

/*
 * This component is built using `gatsby-image` to automatically serve optimized
 * images with lazy loading and reduced file sizes. The image is loaded using a
 * `StaticQuery`, which allows us to load the image from directly within this
 * component, rather than having to pass the image data down from pages.
 *
 * For more information, see the docs:
 * - `gatsby-image`: https://gatsby.dev/gatsby-image
 * - `StaticQuery`: https://gatsby.dev/staticquery
 */

const MessageItem = styled.article``

const MessageList = props => (
  <StaticQuery
    query={graphql`
      query {
        allSanityMessage(sort: { fields: [postDate], order: DESC }) {
          nodes {
            body
            postDate(formatString: "dddd, MMMM Do @ h:mm A")
            image {
              ...ImageWithPreview
            }
          }
        }
      }
    `}
    render={data => {
      return data.allSanityMessage.nodes.map((msg, idx) => {
        const limit = props.limit || 999
        if (idx >= limit) {
          return null
        }

        return (
          <MessageItem className="messageItem">
            <div className="messageDate" key={"date" + idx}>
              {msg.postDate}
            </div>
            <div className="messageContent" key={idx}>
              {msg.body}
            </div>
            {msg.image != null ? (
              <Image
                className="messageImage"
                {...msg.image}
                alt={msg.postDate}
              />
            ) : null}
          </MessageItem>
        )
      })
    }}
  />
)
export default MessageList
